"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fonts = void 0;
var DEFAULT_FONT_DISPLAY = 'swap';
var fonts = [// Volvo Broad
{
  fontFamily: 'Volvo Broad',
  fontWeight: 400,
  fontDisplay: DEFAULT_FONT_DISPLAY,
  src: ['volvo-broad/volvo-broad.woff2', 'volvo-broad/volvo-broad.woff']
}, // Volvo Novum Light
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 200,
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-light.woff2', 'volvo-novum/volvo-novum-greek-light.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 200,
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-light.woff2', 'volvo-novum/volvo-novum-cyrillic-light.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 200,
  src: ['volvo-novum/volvo-novum-light.woff2', 'volvo-novum/volvo-novum-light.woff']
}, // Volvo Novum Light Italic
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 200,
  fontStyle: 'italic',
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-light-italic.woff2', 'volvo-novum/volvo-novum-greek-light-italic.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 200,
  fontStyle: 'italic',
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-light-italic.woff2', 'volvo-novum/volvo-novum-cyrillic-light-italic.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 200,
  fontStyle: 'italic',
  src: ['volvo-novum/volvo-novum-light-italic.woff2', 'volvo-novum/volvo-novum-light-italic.woff']
}, // Volvo Novum Semi Light
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-semi-light.woff2', 'volvo-novum/volvo-novum-greek-semi-light.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-semi-light.woff2', 'volvo-novum/volvo-novum-cyrillic-semi-light.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  src: ['volvo-novum/volvo-novum-semi-light.woff2', 'volvo-novum/volvo-novum-semi-light.woff']
}, // Volvo Novum Semi Light Italic
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  fontStyle: 'italic',
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-semi-light-italic.woff2', 'volvo-novum/volvo-novum-greek-semi-light-italic.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  fontStyle: 'italic',
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-semi-light-italic.woff2', 'volvo-novum/volvo-novum-cyrillic-semi-light-italic.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 300,
  fontStyle: 'italic',
  src: ['volvo-novum/volvo-novum-semi-light-italic.woff2', 'volvo-novum/volvo-novum-semi-light-italic.woff']
}, // Volvo Novum Regular
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-regular.woff2', 'volvo-novum/volvo-novum-greek-regular.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-regular.woff2', 'volvo-novum/volvo-novum-cyrillic-regular.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  src: ['volvo-novum/volvo-novum-regular.woff2', 'volvo-novum/volvo-novum-regular.woff']
}, // Volvo Novum Italic
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  fontStyle: 'italic',
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-italic.woff2', 'volvo-novum/volvo-novum-greek-italic.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  fontStyle: 'italic',
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-italic.woff2', 'volvo-novum/volvo-novum-cyrillic.italic.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  fontStyle: 'italic',
  src: ['volvo-novum/volvo-novum-italic.woff2', 'volvo-novum/volvo-novum-italic.woff']
}, // Volvo Novum Medium
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-medium.woff2', 'volvo-novum/volvo-novum-greek-medium.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-medium.woff2', 'volvo-novum/volvo-novum-cyrillic-medium.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  src: ['volvo-novum/volvo-novum-medium.woff2', 'volvo-novum/volvo-novum-medium.woff']
}, // Volvo Novum Medium Italic
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  fontStyle: 'italic',
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-medium-italic.woff2', 'volvo-novum/volvo-novum-greek-medium-italic.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  fontStyle: 'italic',
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-medium-italic.woff2', 'volvo-novum/volvo-novum-cyrillic-medium-italic.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 500,
  fontStyle: 'italic',
  src: ['volvo-novum/volvo-novum-medium-italic.woff2', 'volvo-novum/volvo-novum-medium-italic.woff']
}, // Volvo Novum Bold
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-bold.woff2', 'volvo-novum/volvo-novum-greek-bold.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-bold.woff2', 'volvo-novum/volvo-novum-cyrillic-bold.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  src: ['volvo-novum/volvo-novum-bold.woff2', 'volvo-novum/volvo-novum-bold.woff']
}, // Volvo Novum Bold Italic
{
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  fontStyle: 'italic',
  unicodeRange: 'U+0370-03FF',
  src: ['volvo-novum/volvo-novum-greek-bold-italic.woff2', 'volvo-novum/volvo-novum-greek-bold-italic.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  fontStyle: 'italic',
  unicodeRange: 'U+0400-04FF',
  src: ['volvo-novum/volvo-novum-cyrillic-bold-italic.woff2', 'volvo-novum/volvo-novum-cyrillic-bold-italic.woff']
}, {
  fontFamily: 'Volvo Novum',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  fontStyle: 'italic',
  src: ['volvo-novum/volvo-novum-bold-italic.woff2', 'volvo-novum/volvo-novum-bold-italic.woff']
}, // Volvo Serif
{
  fontFamily: 'Volvo Serif',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  src: ['volvo-serif/volvo-serif-regular.woff']
}, {
  fontFamily: 'Volvo Serif',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 400,
  fontStyle: 'italic',
  src: ['volvo-serif/volvo-serif-italic.woff']
}, {
  fontFamily: 'Volvo Serif',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  src: ['volvo-serif/volvo-serif-bold.woff']
}, {
  fontFamily: 'Volvo Serif',
  fontDisplay: DEFAULT_FONT_DISPLAY,
  fontWeight: 700,
  fontStyle: 'italic',
  src: ['volvo-serif/volvo-serif-bold-italic.woff']
}];
exports.fonts = fonts;